interface EnvWindow extends Window {
  env: {
    apiUrl: string;
  };
}

const windowEnv = (window as unknown) as EnvWindow;

var API_BASE_URL: string;

if (windowEnv.env.apiUrl) {
  API_BASE_URL = windowEnv.env.apiUrl + '/front/';
} else {
  var currentUrl = window.location.href;
  if (/^.*localhost.*/.test(currentUrl)) {
    API_BASE_URL = 'http://localhost:9080/front/';
  } else if (/^.*tph.engpro.totvs.com.br.*/.test(currentUrl)) {
    API_BASE_URL = 'https://api.tph.engpro.totvs.com.br/front/';
  } else if (/^.*tph-homolog.engpro.totvs.com.br.*/.test(currentUrl)) {
    API_BASE_URL = 'https://api.tph-homolog.engpro.totvs.com.br/front/';
  } else if (/^.*tph.pre.engpro.totvs.com.br.*/.test(currentUrl)) {
    API_BASE_URL = 'https://api.tph.pre.engpro.totvs.com.br/front/';
  } else {
    API_BASE_URL = 'https://api.tph.engpro.totvs.com.br/front/';
  }
}

export const environment = {
  production: true,
  url_api: API_BASE_URL,
};
